// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1KpG4","modalFooterButton":"ModalNotes_modalFooterButton__2J6EU"};